//#region types
import { InvoiceSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { ReadOnlyVerticalFormField, DateDisplay, GroupSectionInline } from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceDateSection: React.FC<InvoiceSectionProps> = (props) => {
  const { values } = props;

  return (
    <GroupSectionInline
      key={`invoice-date-section`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Dates)}
      icon={IconDefinitionConstants.WCalendar}
    >
      {!!values.invoiceDate && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={DateDisplay}
            value={values.invoiceDate}
            label={TranslationKeys.Common.InvoiceDate}
          />
        </Grid>
      )}
      {!!values.dueDate && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={DateDisplay}
            value={values.dueDate}
            label={TranslationKeys.Common.DueDate}
          />
        </Grid>
      )}
      {!!values.deliveryDate && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField
            Component={DateDisplay}
            value={values.deliveryDate}
            label={TranslationKeys.Invoice.DeliveryDate}
          />
        </Grid>
      )}
    </GroupSectionInline>
  );
};

export default InvoiceDateSection;
